import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';

import {
  goToPage,
  reportAnalytics,
  setCellularServices,
  removeSelectedPhone,
  addSelectedPhoneIndex,
  setRegularNumChosenReset,
  setPrettyNumChosenReset,
} from '../saleBlockSlice';
import NewCellNumberSuccess from '../NewCellNumberSuccess/NewCellNumberSuccess';

const NewNumberPage = (props) => {
  if (typeof window.scrollTo === 'function') {
    window.scrollTo(0, 0);
  }
  let flowType = props.flowType;
  const [isNewNumberPageAnimationEnd, setIsNewNumberPageAnimationEnd] = useState(false);

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction:
        flowType == 'existsCustomer'
          ? props.chooseNumber.isExistPhone
            ? 'visibility_6'
            : 'visibility_6a'
          : props.chooseNumber.isExistPhone
          ? 'visibility_17'
          : 'visibility_17a',
      eventLabel: eventLabel,
    });
  }, []);

  //page params
  let isDisplayFooter = true;
  const textContinue = 'המשך';
  const textAdditionalNumber = 'לבחירת מספר נוסף';
  let totalProducts = props.productsInfo.selectedProducts.length;
  let isDisplayAdditionalNumber = totalProducts >= props.service.minimumProducts && totalProducts < props.service.maximumProducts;
  let btnText = totalProducts < props.service.minimumProducts ? textAdditionalNumber : textContinue;
  let currentPageFunction = handleChooseNumberContinue;
  let totalPrice = props.totalPrice;
  let totalPriceOneTime = props.totalPriceOneTime;
  let priceText = 'לחודש';
  let formid = 'sale';

  if (totalProducts == 0) {
    props.goToPage({page: 'chooseNumberPage', percent: 10});
    props.setRegularNumChosenReset(0);
    props.setPrettyNumChosenReset(0);
  }

  const title = props.chooseNumber.isExistPhone ? 'אין כמו להצטרף עם המספר שלכם!' : 'עוד קצת וסיימנו';
  const selectedPhone = props.chooseNumber.isExistPhone ? props.chooseNumber.existPhone : props.chooseNumber.newPhone;
  const selectedProduct = props.productsInfo.selectedProducts[props.productsInfo.selectedProducts.length - 1];
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> {title} </h1>
    </div>
  );

  let currentPageView = (
    <NewCellNumberSuccess
      selectedPhone={selectedPhone}
      selectedProduct={selectedProduct}
      onBackToChooseNumberPage={handleBackToChooseNumberPage}
      isDisplayAdditionalNumber={isDisplayAdditionalNumber}
      onChooseAdditionalNumber={handleChooseAdditionalNumber}
    />
  );

  function handleBackToChooseNumberPage() {
    props.removeSelectedPhone();
    props.goToPage({page: 'chooseNumberPage', percent: 10});
    props.setRegularNumChosenReset(0);
    props.setPrettyNumChosenReset(0);
  }

  function handleChooseAdditionalNumber() {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction: props.flowType == 'existsCustomer' ? 'click_15' : 'click_36',
      eventLabel: eventLabel,
    });

    const cellularServices = {
      B144_IND: props._chooseCellularServices.B144_IND,
      ZSURF_IND: true,
      ZOT_DOWN_CON_IND: props._chooseCellularServices.ZOT_DOWN_CON_IND,
      ZOT_VOTE_IND: props._chooseCellularServices.ZOT_VOTE_IND,
      ZOT_DONATE_IND: props._chooseCellularServices.ZOT_DONATE_IND,
      ZOT_REC_CONT_IND: props._chooseCellularServices.ZOT_REC_CONT_IND,
      ZCN_DOWN_CON_IND: props._chooseCellularServices.ZCN_DOWN_CON_IND,
      ZCN_REC_CONT_IND: props._chooseCellularServices.ZCN_REC_CONT_IND,
      GPRS_ROAM_IND: false,
      INTL_IND: props._chooseCellularServices.INTL_IND,
      ZOT_INFO_IND: props._chooseCellularServices.ZOT_INFO_IND,
      PREMIUM0_IND: props._chooseCellularServices.PREMIUM0_IND,
      PREMIUM1_IND: props._chooseCellularServices.PREMIUM1_IND,
    };
    props.setCellularServices(cellularServices);

    let productsForUpgrade = props.productsInfo.listProductsForUpgrade;
    const filteredProducts = productsForUpgrade?.filter(
      (x) => !!x.isDisplaySimActivation.value == props.productsInfo.baseProduct.isDisplaySimActivation,
    );
    const hasProducts = filteredProducts && filteredProducts.length > 0;

    props.addSelectedPhoneIndex();
    if (!props.productsInfo.baseProduct.isCustomerBasedPackage && hasProducts) {
      props.goToPage({page: 'cellularPackagesPage', percent: 10});
    } else {
      props.goToPage({page: 'chooseNumberPage', percent: 10});
      props.setRegularNumChosenReset(0);
      props.setPrettyNumChosenReset(0);
    }
  }

  function handleChooseNumberContinue() {
    const cellularServices = {
      B144_IND: props._chooseCellularServices.B144_IND,
      ZSURF_IND: true,
      ZOT_DOWN_CON_IND: props._chooseCellularServices.ZOT_DOWN_CON_IND,
      ZOT_VOTE_IND: props._chooseCellularServices.ZOT_VOTE_IND,
      ZOT_DONATE_IND: props._chooseCellularServices.ZOT_DONATE_IND,
      ZOT_REC_CONT_IND: props._chooseCellularServices.ZOT_REC_CONT_IND,
      ZCN_DOWN_CON_IND: props._chooseCellularServices.ZCN_DOWN_CON_IND,
      ZCN_REC_CONT_IND: props._chooseCellularServices.ZCN_REC_CONT_IND,
      GPRS_ROAM_IND: false,
      INTL_IND: props._chooseCellularServices.INTL_IND,
      ZOT_INFO_IND: props._chooseCellularServices.ZOT_INFO_IND,
      PREMIUM0_IND: props._chooseCellularServices.PREMIUM0_IND,
      PREMIUM1_IND: props._chooseCellularServices.PREMIUM1_IND,
    };
    props.setCellularServices(cellularServices);

    const productMakat = props.productsInfo.baseProduct?.productMakat;

    let productsForUpgrade = props.productsInfo.listProductsForUpgrade;
    const filteredProducts = productsForUpgrade?.filter(
      (x) => !!x.isDisplaySimActivation.value == props.productsInfo.baseProduct.isDisplaySimActivation,
    );
    const hasProducts = filteredProducts && filteredProducts.length > 0;

    if (flowType == 'existsCustomer') {
      if (totalProducts < props.service.minimumProducts) {
        props.addSelectedPhoneIndex();
        if (!props.productsInfo.baseProduct.isCustomerBasedPackage && hasProducts) {
          props.goToPage({page: 'cellularPackagesPage', percent: 14});
        } else {
          props.goToPage({page: 'chooseNumberPage', percent: 14});
          props.setRegularNumChosenReset(0);
          props.setPrettyNumChosenReset(0);
        }
      } else {
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'click_17', eventLabel: productMakat});

        if (props.productsInfo.baseProduct.isDisplaySimActivation) {
          props.goToPage({page: 'simActivationPage', percent: 42});
        } else {
          props.goToPage({page: 'userAddressPage', percent: 42});
        }
      }
    } else {
      if (totalProducts < props.service.minimumProducts) {
        props.addSelectedPhoneIndex();
        if (!props.productsInfo.baseProduct.isCustomerBasedPackage && hasProducts) {
          props.goToPage({page: 'cellularPackagesPage', percent: 10});
        } else {
          props.goToPage({page: 'chooseNumberPage', percent: 10});
          props.setRegularNumChosenReset(0);
          props.setPrettyNumChosenReset(0);
        }
      } else {
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'click_38', eventLabel: productMakat});

        if (props.productsInfo.baseProduct.isDisplaySimActivation) {
          props.goToPage({page: 'simActivationPage', percent: 30});
        } else {
          props.goToPage({page: 'addressFormPage', percent: 30});
        }
      }
    }
  }

  function handleRemoveSelectedPhone(index) {
    props.removeSelectedPhone({index: index});
  }

  return (
    <div className='slideAnimation' onAnimationEnd={() => setIsNewNumberPageAnimationEnd(true)}>
      {currentPageHeadline}
      <div className='sale-page-content'>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          removeProduct={handleRemoveSelectedPhone}
          onclick={currentPageFunction}
          price={totalPrice}
          totalPriceOneTime={totalPriceOneTime}
          priceText={priceText}
          formid={formid}
          selectedProducts={props.productsInfo.selectedProducts}
          isNewNumberPageAnimationEnd={isNewNumberPageAnimationEnd}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    service: state.saleBlock.epiServer.service,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,
    chooseNumber: state.saleBlock.chooseNumber,
    productsInfo: state.saleBlock.productsInfo,

    //other states
    _chooseCellularServices: state.chooseCellularServices,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setCellularServices,
  removeSelectedPhone,
  addSelectedPhoneIndex,
  setRegularNumChosenReset,
  setPrettyNumChosenReset,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewNumberPage);
